
import { i18nText } from '@/locales';
import { ProductsOperationEntity, StoreOperation } from "@/entity/warehouse/Operations/Operations.types";
import { DataEntity, ProductsEntity } from "@/entity/warehouse/Operations/Operations.types";
import moment from "moment";

export interface SaleProductItem {
    id: number | null;
    quantity: number | null;
    price: number | null;
    discount: number | null;
    total: number | null;
}

export class SaleProductData implements SaleProductItem {
    id: number | null;
    quantity: number | null;
    price: number | null;
    discount: number | null;
    total: number | null;
    constructor() {
        this.id = null;
        this.quantity = null;
        this.price = 0;
        this.discount = null;
        this.total = 0;
    }
}

export class SaleProductFormData implements StoreOperation {
    id : number;
    date: string;
    time: string;
    store_id: number | null;
    salon_id: number | null;
    storage_operation_type_id: number | null;
    client_name: string;
    client_phone: string;
    client_email: string;
    contractor_id: number | null;
    products: ProductsOperationEntity[];
    cashbox_id: number | null;
    comment: string;
    sum?: number;
    phone_prefix?: string;
    need_pay: boolean;

    constructor() {

        this.id = 0
        this.date = ''
        //this.date = '';
        this.time = ''

        this.store_id = null;
        this.storage_operation_type_id = null;
        this.client_name = "";
        this.client_phone = ""
        this.client_email = "";
        this.contractor_id = null;
        this.products = [];
        this.salon_id = null;

        this.cashbox_id = null;
        this.comment = "";
        this.need_pay = false;
    }
    setDataEntity(data: DataEntity): void {
        //this.date = data.data
        this.id = data['id'];
        this.store_id = data["store_id"];
        this.storage_operation_type_id = data["storage_operation_type_id"];
        this.date = data['date']
        this.time = data['date']
        this.cashbox_id = data["cashbox_id"];
        this.salon_id = data["salon_id"];
        if (data["client"]) {
            this.client_name = data["client"]["name"];
            this.client_email = data["client"]["email"];
            this.client_phone = data["client"]["phone"];
        }
        if (data["products"]) {
            data["products"]?.forEach((product: ProductsEntity) => {
                const newProduct = new SaleProductData();
                //TODO::починить
                // @ts-ignore
                newProduct.id = product["nomenclature"]["id"];
                newProduct.quantity = product["quantity"];
                newProduct.price = product["price"];
                newProduct.discount = Number(product["discount"]);
                newProduct.total = product["total"];
                this.products?.push(newProduct);
            });
        }
    }

    deleteProduct(index: number): void {
        if (this.products) this.products.splice(index, 1);
    }
    addProduct(product: ProductsOperationEntity): void {
        if (this.products) this.products.push(product);
    }
}
export const FormRules = {
    quantity: [{ required: true, message: i18nText("Пожалуйста укажите кол-во"), trigger: "change" }],
    price: [{ required: true, message: i18nText("Пожалуйста укажите кол-во"), trigger: "change" }],
    date: [{ required: true, message: i18nText("Пожалуйста укажите дату"), trigger: "change" }],
    time: [{ required: true, message: i18nText("Пожалуйста укажите время"), trigger: "change" }],
    cashbox_id: [{ required: true, message: i18nText("Пожалуйста укажите кассу"), trigger: "change" }],
    store_id: [{ required: true, message: i18nText("Пожалуйста укажите склад"), trigger: "change" }],
    operation_type_id: [{ required: true, message: i18nText("Пожалуйста тип операции"), trigger: "change" }],
    client_name: [{ required: true, message: i18nText("Пожалуйста укажите клиента"), trigger: "change" }],
    contractor_id: [{ required: true, message: i18nText("Пожалуйста укажите контрагента"), trigger: "change" }],
};
